import Axios from '@/utils/axios'

export default {
  verificaDados: () => Axios.get('/ficha-clinica/verifica-dados'),
  saveDados: ({ estadoCivil, filhos }) => {
    return Axios.post('/ficha-clinica/dados', { estadoCivil, filhos })
  },
  getPerguntasAndRespostas: tipo => {
    return Axios.get(`/ficha-clinica/ocupacional/${tipo}`)
  },
  finalizarFichaClinica: ({ idAso, respostas }) => {
    return Axios.post('/ficha-clinica/ocupacional', {
      idAso,
      respostas
    })
  },
  buscaHorarios: data => Axios.get(`/agendar-exame/horarios/${data}`),
  buscaHorariosAmbulatoriais: tipo => Axios.get(`/agendar-exame/horarios-ambulatoriais/${tipo}`),
  salvarAgendamento: ({ idExame, idHorario }) => Axios.post('/agendar-exame', { idExame, idHorario }),
  getHorarioInfo: idHorario => Axios.get(`/agendar-exame/horario/${idHorario}`),
  updateHorarioAgendamento: ({ idAso, newIdHorario }) => Axios.put('/agendar-exame', { idAso, newIdHorario })
}
